import { render } from "./WrapWithAlertIcon.vue?vue&type=template&id=c3a27174"
import script from "./WrapWithAlertIcon.vue?vue&type=script&lang=js"
export * from "./WrapWithAlertIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__